export default "__VITE_ASSET__BDU8_tSc__"